import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Box
} from '@mui/material';

const CampaignContactStatusDialog = ({ 
    open, 
    onClose, 
    contact, 
    currentStatus, 
    onUpdateStatus,
    campaignId 
}) => {
    const [status, setStatus] = useState(currentStatus || 'pending');

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'processed', label: 'Processed' },
        { value: 'blocked', label: 'Blocked' },
        { value: 'error', label: 'Error' },
        { value: 'email_sent', label: 'Email Sent' },
        { value: 'opened', label: 'Email Opened' },
        { value: 'replied', label: 'Replied' },
        { value: 'completed', label: 'Completed' }
    ];

    const handleSubmit = () => {
        onUpdateStatus(campaignId, contact.id, status);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Update Contact Status</DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body1">
                        {contact?.first_name} {contact?.last_name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        {contact?.email}
                    </Typography>
                </Box>
                <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        label="Status"
                    >
                        {statusOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit} color="primary">
                    Update Status
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CampaignContactStatusDialog;